import { render, staticRenderFns } from "./relation-form.vue?vue&type=template&id=398b701a&"
import script from "./relation-form.vue?vue&type=script&lang=ts&"
export * from "./relation-form.vue?vue&type=script&lang=ts&"
import style0 from "./relation-form.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports